<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="16"
      cy="16"
      r="16"
      fill="#F8FAFC"
    />
    <path
      d="M19.3654 8H12.6331C11.9893 8 11.4691 8.52214 11.4691 9.16598V22.8355C11.4691 23.4774 11.9893 24 12.6331 24H19.3654C20.0082 24 20.5303 23.4779 20.5303 22.8355V9.16598C20.5298 8.52214 20.0082 8 19.3654 8ZM19.6572 20.9636H12.3422V9.96686H19.6572V20.9636ZM17.5601 9.18315H14.4389V8.8428H17.5606L17.5601 9.18315ZM18.8958 9.02762C18.8958 9.19224 18.7614 9.32555 18.5973 9.32555C18.4327 9.32555 18.2989 9.19173 18.2989 9.02762C18.2989 8.8635 18.4327 8.72968 18.5973 8.72968C18.7619 8.72918 18.8958 8.863 18.8958 9.02762ZM17.4202 22.7578H14.5777V21.8832H17.4202V22.7578Z"
      fill="#082655"
    />
  </svg>
</template>

<script>
export default {
  name: 'PhoneIcon32'
};
</script>

<style scoped>

</style>